import anamnese from './anamnese';
import onboarding from './onboarding';
import satisfacao from './satisfacao';

import consultoriaNutricionalInicial from './consultoria-nutricional-inicial';
import acompanhamentoNutricional from './acompanhamento-nutricional';
import reeducacaoAlimentar from './reeducacao-alimentar';

import avaliacaoFisicaPersonal from './avaliacao-fisica-personal';
import evolucaoSemanalTreino from './evolucao-semanal-treino';
import anamneseFitnessCompleta from './anamnese-fitness-completa';

import leadTreinoOnline from './lead-treino-online';
import leadCoachingFitness from './lead-coaching-fitness';
import leadDesafio30Dias from './lead-desafio-30-dias';

import leadNutricaoOnline from './lead-nutricao-online';
import leadEmagrecimento from './lead-emagrecimento';

import anamneseCorrida from './anamnese-corrida-iniciante';
import anamseCorridaAvancado from './anamnese-corrida-avancado';

import satisfacaoPosConsulta from './satisfacao-pos-consulta';
import npsProgramaTreino from './nps-programa-treino';

const templates = [
    // Nutrição
    consultoriaNutricionalInicial,
    acompanhamentoNutricional,
    reeducacaoAlimentar,
    leadNutricaoOnline,
    leadEmagrecimento,
    satisfacaoPosConsulta,

    // Treino
    avaliacaoFisicaPersonal,
    evolucaoSemanalTreino,
    anamneseFitnessCompleta,
    leadTreinoOnline,
    leadCoachingFitness,
    leadDesafio30Dias,
    npsProgramaTreino,

    // Corrida
    anamneseCorrida,
    anamseCorridaAvancado,

    // Genéricos (legado)
    anamnese,
    onboarding,
    satisfacao,
];

export default templates;
